// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__-6TBG","carousel-item":"Carousel_carousel-item__DnBLj","selected-item":"Carousel_selected-item__IXeq5"};